import { render, staticRenderFns } from "./LoginCallBack.vue?vue&type=template&id=c9a738b8"
import script from "./LoginCallBack.vue?vue&type=script&lang=ts"
export * from "./LoginCallBack.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports